import { Layout } from 'antd';
import React from 'react';
import { Routes, Route } from 'react-router';

import { PATH } from 'constants/RoutesConstants';
import FleetbackLoader from 'ui/base/FleetbackSplash';

import Header from './header/Header';
import ForgotPassword from '../../common/auth/forgotPassword';
import CheckMail from '../../common/auth/forgotPassword/CheckMail';
import ResetPassword from '../../common/auth/forgotPassword/ResetPassword';
import Login from '../../common/auth/login';

const PublicLayout = () => (
  <Layout>
    <Header />
    <Layout>
      <Routes>
        <Route {...PATH.FORGOT_PASSWORD}>
          <Route index Component={ForgotPassword} />
          <Route path="check-mail" Component={CheckMail} />
          <Route path="reset" Component={ResetPassword} />
        </Route>

        <Route {...PATH.MAGIC_LINK} Component={FleetbackLoader} />

        {/* if any other path is return we explicitly return to an exact path which is "/" so the rendered component will be the login */}
        <Route path="*" element={<Login />} />
      </Routes>
    </Layout>
  </Layout>
);

export default PublicLayout;
